import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ReportsIcon } from '../../icons';

export const CompanyGroupCard = ({
  className,
  cardRef,
  member,
  selectedAfm,
  handleCardClick,
  handleEnterClick
}) => {
  const isSelected = useMemo(() => {
    return member && selectedAfm === member;
  }, [selectedAfm, member]);

  return (
    <li
      ref={cardRef}
      className={clsx(
        `p-3 flex w-full items-center justify-between gap-3 rounded-lg h-fit ${
          isSelected ? 'bg-[#282828] text-white' : ' bg-white'
        }`,
        className
      )}
      role={handleCardClick && 'button'}
      // onClick={handleCardClick && handleCardClick}
      onClick={() => {handleEnterClick(member?.user.id)}}
      key={member?.id}
    >
      <div className="flex items-center gap-2 ">
        <div className='bg-powdergrey rounded-full p-2'>
          <ReportsIcon width='30' height='30' stroke='black' />
        </div>
        <div className="flex-col text-body truncate max-xl:w-[60px]" title={member.name}>          
          <p className='text-base'>{member?.user.company}</p>
          <p className='font-bold'>{member?.user.afm}</p>
        </div>
        
      </div>
      {/* <button className='self-end' onClick = {handleEnterClick}>
          <EnterIcon height="40" width="40" stroke={isSelected && '#FFFFFF'}/>
      </button> */}
    </li>
  );
};